import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, TextField, Box } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import reportsSx from './Reports.styles';
import { actions } from './Reports.redux';
import DashboardCard from "components/DashboardCard";
import { Search } from "@mui/icons-material";



const TemplateSearch = () => {
	const theme = useTheme();
	const sx = reportsSx(theme);
	const dispatch = useDispatch();
	const searchTerms = useSelector(state => state.reports.templateSearch);
	const loading = useSelector(state => state.reports.loading);
	const setSearchTerm = (key, value) => dispatch(actions.setSearchTerm('templateSearch', key, value));


	const handleChange = e => setSearchTerm(e.target.name, e.target.value);

	const handleSubmit = e => {
		e.preventDefault();
		dispatch(actions.setSubState('templates', { pageNumber: 0 }));
		dispatch(actions.loadTemplates());
	};


	const handleReset = () => {
		if(!searchTerms.template_name) {
			return false;
		}

		setSearchTerm('template_name', '');
		dispatch(actions.setSubState('templates', { pageNumber: 0 }));
		dispatch(actions.loadTemplates());
	};


	return (
		<Box sx={sx.searchContainer}>
			<DashboardCard
				color={'amber'}
				icon={<Search />}
				topContent={"Layout Search"}
				topLabel="Enter search criteria below"
				size="xl"
			>
				<form method="post" onSubmit={handleSubmit}>
					<Grid container spacing={4}>
						<Grid size={{ xs: 12 }}>
							<TextField
								label="Layout Name"
								variant="outlined"
								fullWidth
								value={searchTerms.template_name}
								name="template_name"
								onChange={handleChange}
							/>
						</Grid>

						<Grid size={{ xs: 12 }}>
							<Button
								variant="contained"
								color="primary"
								size="large"
								sx={sx.searchButtons}
								disabled={loading}
								type="submit"
								onClick={handleSubmit}
							>
								Search
							</Button>

							<Button
								variant="outlined"
								color="primary"
								size="large"
								sx={sx.searchButtons}
								disabled={loading}
								onClick={handleReset}
							>
								Reset
							</Button>
						</Grid>

					</Grid>
				</form>
			</DashboardCard>
		</Box>

	);
};


export default TemplateSearch;
